// Design's `scale.change` (design/system/tokens.css `--ba-scale-change`), the signed scale the engine asserts (api.rs)
// and the app draws itself where the engine doesn't: the ΔFC matrix (features/DfcMatrix.tsx) and the text-to-map
// slices (features/text.ts). Violet below, slate at the centre, orange above.

export const CHANGE: [number, [number, number, number]][] = [
  [0, [0x9a, 0x8c, 0xff]],
  [0.25, [0x5f, 0x5d, 0x98]],
  [0.5, [0x2b, 0x31, 0x3c]],
  [0.75, [0x8a, 0x5e, 0x46]],
  [1, [0xe8, 0x86, 0x2e]],
];

/** The scale's colour at `t` in [0, 1], 0.5 the centre; clamped outside. */
export function changeColour(t: number): [number, number, number] {
  const x = Math.min(1, Math.max(0, t));
  for (let i = 1; i < CHANGE.length; i++) {
    const [t1, c1] = CHANGE[i]!;
    if (x <= t1) {
      const [t0, c0] = CHANGE[i - 1]!;
      const u = (x - t0) / (t1 - t0);
      return [0, 1, 2].map((k) => Math.round(c0[k]! + (c1[k]! - c0[k]!) * u)) as [number, number, number];
    }
  }
  return CHANGE[CHANGE.length - 1]![1];
}
